'use client';

import { Button, Group } from '@mantine/core';
import { modals } from '@mantine/modals';

import { ErrorAlert } from './ErrorAlert';

export function showErrorAlert(message: string): void {
	const modalId = `error:${message}`;

	modals.open({
		modalId,
		title: 'Error',
		children: (
			<>
				<ErrorAlert>{message}</ErrorAlert>
				<Group justify="flex-end" mt="md">
					<Button onClick={() => modals.close(modalId)}>OK</Button>
				</Group>
			</>
		),
	});
}
